import { render, staticRenderFns } from "./AccountPreferences.vue?vue&type=template&id=963cbaaa"
import script from "./AccountPreferences.vue?vue&type=script&lang=js"
export * from "./AccountPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports